import React from 'react';
import BusinessCellStyles from './styled/BusinessCellStyles';
import ServiceTag, { SKINS, TagGroup } from 'components/ServiceTag';
import { HighPrioTag } from '../../high-prio-order';

const t = {
  ftl: 'FTL',
  ltl: 'LTL',
  ONTRUCK24: '24h',
  PRIO: 'PRIO',
  RECOVERING: 'RECOVERING',
  LHE: 'LHE',
};

const BusinessCell = ({
  isFtl,
  isXDock,
  isHighPrio,
  isRecovering,
  serviceType,
  isLHExpress,
  className,
}) => {
  const showServiceType = !!serviceType && !isLHExpress;

  return (
    <div className={className}>
      <TagGroup>
        <ServiceTag text={isFtl ? t.ftl : t.ltl} skin={isFtl ? SKINS.grey : SKINS.white} size="M" />
        {isRecovering && <ServiceTag text={t.RECOVERING} skin={SKINS.accent} size="M" />}
        {isXDock && <ServiceTag text={t.ONTRUCK24} skin={SKINS.deepPurple} size="M" />}
        {isLHExpress && <ServiceTag text={t.LHE} skin={SKINS.lhExpress} size="M" />}
        {showServiceType && (
          <ServiceTag text={t[serviceType] || serviceType} skin={SKINS.deepPurple} size="M" />
        )}
        {!!isHighPrio && <HighPrioTag />}
      </TagGroup>
    </div>
  );
};

export default BusinessCellStyles(BusinessCell);
